import { QueryFunctionContext } from '@tanstack/react-query';
import { isEmpty } from 'es-toolkit/compat';

import { queryNotificationServices } from 'api/notificationServices';
import { useQueryWithErrorAndRetrySnackbar } from 'utils/useQueryWithErrorAndRetrySnackbar';

export type NotificationQueryKey =
  | ['notification', { ids: string[]; arns?: undefined }]
  | ['notification', { arns: string[]; ids?: undefined }];

export const useNotificationQueriesById = (notificationIds: string[], debug = false) =>
  useQueryWithErrorAndRetrySnackbar(
    ['notification', { ids: notificationIds }],
    ({ signal }: QueryFunctionContext) => queryNotificationServices({ ids: notificationIds, signal }),
    {
      enabled: !isEmpty(notificationIds),
      queriedEntityName: 'Notification Services by ID',
      consoleOnly: !debug,
    }
  );

export const useNotificationQueriesByArn = (notificationArns: string[], debug = false) =>
  useQueryWithErrorAndRetrySnackbar(
    ['notification', { arns: notificationArns }],
    ({ signal }: QueryFunctionContext) => queryNotificationServices({ arns: notificationArns, signal }),
    {
      enabled: !isEmpty(notificationArns),
      queriedEntityName: 'Notification Services by ARN',
      consoleOnly: !debug,
    }
  );
